import { Route, Routes } from 'react-router-dom-v5-compat'
import { UserAccount } from './AdminAccounts/UserAccount'

const SettingsRoutes = () => {
    return (
      <Routes>
          <Route path="administration">
              <Route path="account" element={<UserAccount />} />
          </Route>
      </Routes>
    )
}

export { SettingsRoutes }
